import React from "react"
import { Link } from "gatsby"

export const DropdownMenuItems = ({ dropdown_menu_items, page }) => {
  const isPartiallyActiveSubmenuDropdownItem = ({ isPartiallyCurrent }) => {
    return isPartiallyCurrent
      ? { className: "submenu-dropdown-item-active" }
      : {}
  }

  const isCurrentlyActiveSubmenuDropdownItem = ({ isCurrent }) => {
    return isCurrent ? { className: "submenu-dropdown-item-active" } : {}
  }
  return (
    <div className={`submenu-dropdown-menu-${page}`} role="menu">
      {dropdown_menu_items.map(
        ({ link, label, redundand, additional_classes }, index) => {
          return (
            <Link
              key={`dropdown-linkitem-${page}-${index}`}
              to={link}
              className={`submenu-dropdown-item ${
                !!additional_classes ? additional_classes : ""
              }`}
              getProps={
                redundand
                  ? isCurrentlyActiveSubmenuDropdownItem
                  : isPartiallyActiveSubmenuDropdownItem
              }
            >
              {label}
            </Link>
          )
        }
      )}
    </div>
  )
}
